export default {
  'moduleTitle.address': 'Adres',
  'moduleTitle.address_details': 'Details adres',
  'moduleTitle.activity_details': 'Details activiteit',
  'moduleTitle.add_log': 'Post toevoegen',
  'moduleTitle.award_level': 'Award niveau',
  'moduleTitle.adventurous_journey': 'Expeditie',
  'moduleTitle.already_assessed': 'Al beoordeeld!',
  'moduleTitle.approved': 'Goedgekeurd!',
  'moduleTitle.assessor_details': 'Details Assessor',
  'moduleTitle.authorising_contact_license_holder': 'Bevoegd contactpersoon / licentie houder',
  'moduleTitle.category_journey_details': '{category} Expeditie details',
  'moduleTitle.complete_report': 'Verslag afronden',
  'moduleTitle.completed_progress': 'Afgerond {finished} / {total}',
  'moduleTitle.congratulation': 'Gefeliciteerd!',
  'moduleTitle.confirming_email_address': 'Bevestig je e-mailadres',
  'moduleTitle.contact_details': 'Contact details',
  'moduleTitle.edit_log': 'Wijzig post',
  'moduleTitle.event_journey': '{event} Expeditie',
  'moduleTitle.forgotten_password': 'Wachtwoord vergeten?',
  'moduleTitle.great_you_are_almost_there': 'Super, je bent er bijna! Je moet alleen nog betalen.',
  'moduleTitle.home_address': 'Huisadres',
  'moduleTitle.journey_overview': 'Overzicht Expeditie',
  'moduleTitle.log_detail': 'Details logboek',
  'moduleTitle.login': 'Inloggen',
  'moduleTitle.new_activity': 'Nieuwe activiteit',
  'moduleTitle.new_event_journey': 'Nieuwe {event} Expeditie',
  'moduleTitle.new_residential_project': 'Nieuw Residentieel Project',
  'moduleTitle.notRegistred': 'Nog niet geregistreerd?',
  'moduleTitle.nominated_award_leader_contact_details': 'Contactgegevens van de voorgestelde Awardbegeleider ',
  'moduleTitle.nominated_award_leader': 'Voorgestelde Awardbegeleider',
  'moduleTitle.organisation_address': 'Adres organisatie',
  'moduleTitle.organisation_details': 'Details organisatie',
  'moduleTitle.online_record_book_account': 'Account Online Record Book',
  'moduleTitle.page_not_found': '404 - Pagina niet gevonden',
  'moduleTitle.personal_details': 'Persoonlijke informatie',
  'moduleTitle.preparation_and_training': 'Voorbereiding & Training',
  'moduleTitle.profile_guardian_consent': 'Toestemming ouder/voogd',
  'moduleTitle.profile_questions': 'Profiel vragen',
  'moduleTitle.registration_for_level': 'Registratie voor volgende Award',
  'moduleTitle.residential_project': 'Residentieel Project',
  'moduleTitle.residential_project_details': 'Details Residentieel Project',
  'moduleTitle.reset_password': 'Reset wachtwoord',
  'moduleTitle.welcome_to_the_orb': 'Welkom bij het Online Record Book!',
  'moduleTitle.we_have_sent_you_an_email': 'We hebben je een e-mail gestuurd met een activatie link',
  'moduleTitle.your_registration_is_complete': 'Je registratie is compleet',
  'formTitle.activity_details': 'Details activiteit',
  'formTitle.assessor_details': 'Details Assessor',
  'formTitle.supervisors_details': 'Details Supervisor',
  'formTitle.preparation_and_training_activities': 'Activiteiten Voorbereiding & Training',
  'formTitle.added_preparation_activities': 'Heeft activiteiten Voorbereiding & Training toegevoegd',
  'label.add_picture': 'Foto toevoegen',
  'label.address_first_line': 'Adres',
  'label.address_second_line': 'Adres',
  'label.are_you_already_running_award': 'Draai jij het Awardprogramma al?',
  'label.are_you_the_main_award_leader': 'Bent u de Hoofdawardbegeleider of de Coördinator van uw Award unit?',
  'label.award_participant': 'Award deelnemer',
  'label.award_leader': 'Awardbegeleider',
  'label.birthdate': 'Geboortedatum',
  'label.category': 'Categorie',
  'label.change_locale': 'Verander locatie',
  'label.choose_project': 'Kies activiteit',
  'label.city': 'Woonplaats',
  'label.choose_as_major_activity': 'Kies als hoofdonderdeel',
  'label.date': 'Datum',
  'label.date_of_birth': 'Geboortedatum',
  'label.description_of_progress': 'Beschrijving van je voortgang',
  'label.duration': 'Duur (minuten)',
  'label.email': 'E-mail',
  'label.email_address': 'E-mailadres',
  'label.email_again': 'Bevestig je e-mailadres',
  'label.employment_status': 'Werk?',
  'label.end_date': 'Einddatum',
  'label.enter_his_email': 'Voeg e-mailadres toe',
  'label.entered_transaction_id': 'Je Transactie ID',
  'label.first_name': 'Voornaam',
  'label.gender': 'Geslacht',
  'label.goal': 'Doel',
  'label.journey_activity': 'Expeditie activiteit',
  'label.journey_objective': 'Expeditie doel',
  'label.journey_observations': 'Observaties van Expeditie',
  'label.journey_type': 'Type Expeditie',
  'label.last_name': 'Achternaam',
  'label.level': 'Niveau',
  'label.location': 'Locatie',
  'label.logout': 'Uitloggen',
  'label.major': 'Hoofdonderdeel',
  'label.middle_name': 'Tweede naam',
  'label.mode_of_transport': 'Wijze van vervoer',
  'label.my_award_leader': 'Mijn Awardbegeleider',
  'label.name': 'Naam',
  'label.nationality': 'Nationaliteit',
  'label.no': 'Nee',
  'label.no_results': 'Geen resultaten',
  'label.note': 'Opmerking',
  'label.note_for_assessor': 'Opmerking voor Assessor',
  'label.note_for_leader': 'Opmerking voor Awardbegeleider',
  'label.optional': 'Optioneel',
  'label.organisation_name': 'Naam Organisatie',
  'label.organisation_type': 'Type Organisatie',
  'label.others': 'Anders',
  'label.password': 'Wachtwoord',
  'label.password_again': 'Herhaal wachtwoord',
  'label.project_location': 'Projectlocatie',
  'label.pay_online': 'Betaal online',
  'label.pay_award_leader_or_unit': 'Betaal Awardbegeleider of Unit',
  'label.payment_not_required': 'Deelnemer hoeft niet te betalen',
  'label.payment_type': 'Manier van betalen:',
  'label.phone': 'Telefoon',
  'label.phone_number': 'Telefoonnummer',
  'label.phone_type': 'Type telefoon',
  'label.profile': 'Profiel',
  'label.reset_password': 'Reset wachtwoord',
  'label.region': 'Staat/Provincie/Regio',
  'label.relationship': 'Relatie',
  'label.role_in_organisation': 'Rol binnen organisatie',
  'label.select_country': 'Selecteer Land',
  'label.select_your_au': 'Typ hier de naam van je Awardunit: ',
  'label.start_typing': 'Begin met typen',
  'label.start_date': 'Startdatum',
  'label.select': 'Selecteer',
  'label.select_async': 'Begint te typen...',
  'label.select_your_operating_authority': "Typ nu in 'Licensed units' ",
  'label.specify_category': 'Specificeer je categorie, alsjeblieft. ',
  'label.subcategory': 'Subcategorie',
  'label.title': 'Title',
  'label.username': 'Gebruikersnaam',
  'label.what_is_your_role': 'Wat is jouw rol binnen je organisatie?',
  'label.where_have_you_completed': 'Waar heb je je vorige Award behaald?',
  'label.yes': 'Ja',
  'label.your_changes_havent_been_saved': 'Je veranderingen zijn niet opgeslagen. Gegevens zullen verloren gaan',
  'label.zip': 'Postcode',
  'label.adventurous_journey': 'Expeditie',
  'label.after_your_journey_describe': 'Beschrijf jouw observaties van je Expeditie in een paar zinnen.',
  'label.because_your_age_is_under_18': 'Omdat je onder de 18 bent, hebben we toestemming nodig van je ouder/voogd.',
  'label.before_you_head_to_journey': 'Voordat je kunt doorgaan met je Expeditie, moet je eerst de Voorbereiding & Training voltooien. ',
  'label.before_entering_new_level': 'Voordat je doorgaat met de volgende Award, wil je eerst bevestigen dat je persoonlijke informatie nog steeds up-to-date is?',
  'label.bring_required_amount_to_your_award_leader': '----',
  'label.do_you_have_any_other_level': 'Heb je al eerder een Award behaald?',
  'label.do_you_know_who_is_your_award_leader': 'Weet je wie je Awardbegeleider is?',
  'label.going_on_an_expedition': 'Op Expeditie gaan geeft je de kans om een avontuur aan te gaan, als een team te werken en op eigen initiatief te handelen.',
  'label.going_on_residential_gives_chance': 'Een Residentieel Project geeft je de kans om met mensen van verschillende achtergronden te werken en meer zekerheid te krijgen om in nieuwe omgevingen te wonen.',
  'label.i_confirm_that_i_meet': 'Ik bevestig dat ik aan alle eissen van de NAO voldoe.',
  'label.i_agree_to_volunteer_code': 'Ik ga akkoord met de gedragscode voor vrijwilligers. Klik hier voor meer informatie.',
  'label.i_have_read_the_terms_and_conditions': 'Ik heb de Algemene Voorwaarden gelezen en ik ga akkoord',
  'label.i_will_bring_the_consent_to_my_award_leader_later': 'Ik zal later toestemming geven aan mijn Awardbegeleider',
  'label.if_you_are_from_orphanage': 'Bijvoorbeeld, als je school of jongerenorganisatie voor jou betaald',
  'label.here_you_can_add_activity': 'Hier kun je extra Voorbereiding & Training activiteiten toevoegen',
  'label.how_do_you_want_to_apply': 'Hoe wil je je aanmelden:',
  'label.my_parent_consent_has_been_already_given': 'De toestemming van mijn ouder/voogd is al aan de Awardbegeleider gegeven',
  'label.my_parent_will_confirm_consent_by_email': 'Mijn ouder/voogd zal toestemming geven via een e-mail',
  'label.major_activity_means_that_you_have_to_spent': 'Je hoofdonderdeel zal twee keer zoveel tijd kosten in vergelijking met ander activiteiten.',
  'label.not_sure_about_your_auth': 'Niet zeker over de naam van je Awardunit? Neem contact met ons op. Als je niet zeker bent waar je moet registreren, neem dan contact op met Award Nederland',
  'label.page_not_found': '404 - Pagina niet gevonden',
  'label.please_fill_in_the_following': 'Vul hier de gegevens in van de bevoegd contactpersoon / licentie houder van je organsisatie',
  'label.register_a_new_account_as': 'Registreer je nieuwe account als:',
  'label.residential_project': 'Residentieel Project',
  'label.select_your_award_unit': 'Type hier de naam van je Awardunit',
  'label.the_expedition_can_be_faraway': 'De Expeditie kun je zo ver weg en zo dichtbij doen als je wil, en er zijn honderden manieren om dit aan te pakken.',
  'label.to_log_your_process_on_orb': 'Om je voortgang vast te leggen in het Online Record Book (ORB), heb je een persoonlijk ORB account nodig. <br /> Vul hier je gegevens in.',
  'label.waiting_for_assessment': 'In afwachting van een beoordeling',
  'label.waiting_for_sign_off': 'In afwachting van aftekening door Awardbegeleider',
  'label.we_have_sent_you_an_email': 'We hebben je een e-mail gestuurd met een activatie link.',
  'label.what_level_of_the_award': 'Voor welke Award wil je je registreren?',
  'label.you_are_now_registering_as_participant': 'Je bent je nu aan het registreren als Awarddeelnemer',
  'label.you_are_now_registering_as_award_unit': 'Je bent je nu aan het registreren als Awardunit',
  'label.you_can_use_my_photos_for_promotional_purposes': 'Als Awarddeelnemer geef ik toestemming om mijn afbeeldingen te gebruiken voor promotionele doeleinden.',
  'label.you_can_send_activity_for_approval': 'Je kunt je activiteit nu voor goedkeuring naar je Assessor sturen ',
  'label.you_can_send_activity_for_leader': 'Je kunt je activiteit nu voor goedkeuring naar je Awardbegeleider sturen ',
  'label.you_can_send_residential_project_to_leader': 'Je kunt je Residentieel Project nu voor goedkeuring naar je Awardbegeleider sturen.',
  'label.you_have_finished_now_send_to_approval': 'Je hebt je activiteit afgerond. Je kunt het nu voor goedkeuring naar je Assessor sturen. Je kunt hieronder een persoonlijke opmerking plaatsen.',
  'label.preparation_and_training': 'Voorbereiding & Training',
  'label.you_will_be_redirected_to_the_payment': 'Je wordt doorverwezen naar de betaalopties waar je kunt kiezen tussen betaling met bankkaart of credit cart.',
  'label.you_will_be_the_first_award_leader': 'Je bent de eerste Awardbegeleider in je organisatie. Je hebt het recht om meer Awardbegeleiders en deelnemers toe te voegen, en de voortgang van de Award te beheren in het Online Record Book systeem.',
  'label.youll_receive_a_notification': 'Je zult een melding krijgen als je Awardbegeleider je registratie heeft goedgekeurd. Je kun inloggen op het Online Record Book <a>here</a> (totdat je Awardbegeleider je registratie heeft goedgekeurd kun je slechts beperkt gebruik maken van de app)',
  'label.your_parent_email': 'E-mail ouder/voogd',
  'label.your_parent_first_name': 'Voornaam ouder/voogd',
  'label.your_parent_last_name': 'Achternaam ouder/voogd',
  'label.your_report_approve_now_send_to_leader': 'Je verslag is goedgekeurd door je Assessor. Je kunt het nu indienen bij je Awardbegeleider. Je kunt hieronder een persoonlijke opmerking achterlaten.',
  'label.there_are_loads_of_exciting_possibilities': 'Er zijn een heleboel gave mogelijkheden en kansen. Kies iets wat jij leuk zult vinden.',
  'label.your_residential_project_has_been_setup': 'Je Residentieel Project is georganiseerd en is verzonden naar je Awardbegeleider ter goedkeuring',
  'label.your_report_has_been_sent_assessor': 'Je verslag is verzonden naar je Beoordelaar ter goedkeuring',
  'label.your_report_has_been_sent_leader': 'Je verslag is verzonden naar je Beoordelaar ter goedkeuring',
  'label.your_residential_project_is_complete': 'Je Residentieel Project is voltooid',
  'label.to_work_on_the_online': 'Om te werken in het Online Record Book (ORB) heb je een persoonlijke ORB account nodig.',
  'label.we_will_send_you_an_email': 'We zullen je een e-mail sturen als je ORB account registratie is voltooid',
  'label.if_you_have_any_problems_or_doubts': 'Mocht je problemen ondervinden of twijfelen, neem dan contact op met Award Nederland voor meer informatie',
  'label.are_you_sure_you_want_to_leave': 'Weet je zeker dat je wil gaan? Gegevens zullen verloren gaan.',
  'label.no_logs_yet': 'Nog geen posts. <br /> Voeg je eerste post toe door te drukken op de "Post toevoegen"- knop',
  'label.menu': 'Menu',
  'notifications.award_unit_has_been_created': 'Award unit is aangemaakt',
  'notifications.authorization_code_is_not_valid': 'Autorisatie code is ongeldig',
  'notifications.email_has_been_confirmed': 'E-mailadres is bevestigd',
  'notifications.leader_has_been_created': 'Awardbegeleider is aangemaakt',
  'notifications.participant_has_been_created': 'Deelnemer is aangemaakt',
  'notifications.email_with_instructions_has_been_sent': 'E-mail met instructies zijn verzonden',
  'notifications.your_new_password_has_been_set': 'Je nieuwe wachtwoord is ingesteld',
  'notifications.success': 'Succes',
  'notifications.unknown_role': 'Rol onbekend',
  'notifications.waiting_for_approval': 'In afwachting van goedkeuring',
  'notifications.activity_cannot_be_created': 'Activiteit kan niet worden aangemaakt totdat je registratie is goedgekeurd',
  'notifications.new_activity_has_been_added': 'Nieuwe activiteit toegevoegd',
  'notifications.new_log_has_been_added': 'Nieuwe post aangemaakt',
  'notifications.log_has_been_deleted': 'Post verwijderd',
  'notifications.log_has_been_modified': 'Post gewijzigd',
  'notifications.adventurous_journey_cannot_be_created_until_approved': 'Expeditie kan niet worden aangemaakt totdat je registratie is voltooid',
  'notifications.new_participant_event_has_been_added': 'Nieuw deelnemer evenement is toegevoegd',
  'notifications.participant_event_has_been_completed': 'Deelnemersevenement voltooid',
  'notifications.training_and_practice_modified': 'Training & Oefening gewijzigd',
  'notifications.completion_residential_project_completed': 'Residentieel Project is afgerond',
  'notifications.new_residential_project_has_been_added': 'Nieuw Residentieel Project is toegevoegd',
  'notifications.residential_project_cannot_be_created_until_approved': 'Residentieel Project kan niet worden toegevoegd totdat je registratie is goedgekeurd',
  'notifications.already_assessed_sent': 'Verzoek tot goedkeuring Awardbegeleider verzonden',
  'notifications.assessment_request_sent': 'Aanvraag beoordeling verzonden',
  'notifications.leader_approval_sent': 'Verzoek tot goedkeuring Awardbegeleider verzonden',
  'tabs.logs': 'Posts',
  'tabs.new': 'Nieuw',
  'tabs.overview': 'Overzicht',
  'tabs.report': 'Verslag',
  'button.add_activity': 'Voeg activiteit toe',
  'button.add_log': 'Voeg post toe',
  'button.continue_here': 'Ga hier door',
  'button.continue': 'Ga door',
  'button.continue_to_award': 'Ga verder naar de Award',
  'button.delete': 'Verwijderen',
  'button.edit': 'Wijzigen',
  'button.edit_log': 'Post wijzigen',
  'button.finish': 'Afsluiten',
  'button.forgot_your_password': 'Je wachtwoord vergeten?',
  'button.i_already_have_assessment': 'Ik heb al een beoordeling',
  'button.leave_anyway': 'Toch gaan',
  'button.login': 'Inloggen',
  'button.no': 'Nee',
  'button.register': 'Registreren',
  'button.send': 'Verzenden',
  'button.send_for_approval': 'Verzenden voor goedkeuring',
  'button.setup': 'Setup',
  'button.setup_residential': 'Residentieel Project opzetten',
  'button.stay': 'Blijven',
  'button.submit': 'Indienen',
  'button.update': 'Updaten',
  'button.yes': 'Ja',
  'errors.at_least_num_characters': 'Gebruik tenminste {length} karakters',
  'errors.do_not_match': 'Komt niet overeen',
  'errors.include_at_least_one_number': 'Gebruik tenminste één cijfer',
  'errors.include_both_lower_and_upper_case': 'Gebruik zowel hoofdletters als kleine letters',
  'errors.invalid_phone_format': 'Ongeldig telefoonsysteem',
  'errors.invalid_email_address': 'Ongeldig e-mailadres',
  'errors.required_field': 'Verplicht veld',
  'errors.must_be_at_least': 'Moet tenminste uit {min} karakters bestaan',
  'errors.must_be_no_more_than': 'Mag maximaal uit {max} karakters bestaan',
  'errors.must_be_an_integer': 'Moet een rond getal zijn',
  'errors.must_contain_at_least': 'Moet tenminste één cijfer bevatten',
  'errors.must_include_at_least': 'Je moet tenminste een hoofdletter gebruiken',
  'errors.must_be_one_of': 'Kies er een: {enums}',
  'errors.you_must_be_younger_than': 'Je moet jonger zijn dan {years} jaar en {months} maanden om je te registreren voor de Award. Praat hierover met de Awardbegeleider of met Award Nederland',
  'errors.you_must_be_older_than': 'Je moet ouder zijn dan {years} jaar en {months} maanden om je te registreren voor de Award. Praat hierover met de Awardbegeleider of met Award Nederland',
  'errors.email_address_is_in_use_please_sign': 'E-mailadres is al in gebruik, als je wil registreren voor de volgende Award, log dan in op je account.',
  'errors.email_address_is_in_use': 'E-mailadres is al in gebruik.',
  'errors.sorry_we_already_have_this_email': "Helaas hebben we al een account geregistreerd met dit e-mailadres. Als je wil starten met het volgende niveau, <a href='/]>log in op je account</a> en selecteer de optie Start volgende Award",
  'wizard.authorising_contact': 'Bevoegd contact',
  'wizard.award_leader_contact': 'Contactinformatie Awardbegeleider',
  'wizard.award_unit_details': 'Details Award unit',
  'wizard.contact_details': 'Contact detaisl',
  'wizard.contacts': 'Contacten',
  'wizard.level': 'Award level',
  'wizard.level_selection': 'Awardkeuze',
  'wizard.leader_details': 'Details Awardbegeleider',
  'wizard.nominated_award_leader': 'Genomineerde Awardbegeleider',
  'wizard.orb_account': 'ORB account',
  'wizard.parent_consent': 'Ouderlijke toestemming',
  'wizard.participant_details': 'Details deelnemer',
  'wizard.profile': 'Profiel',
  'wizard.payment': 'Betaling',
  'wizard.select_award_unit': 'Selecteer Award unit',
  'wizard.unit_details': 'Details Award unit',
  'wizard.welcome': 'Welkom!',
  'wizard.your_details': 'Jouw gegevens',
  'awardUnit.do_you_want_to_create': 'Wil je een nieuwe Award unit aanmaken?',
  'parent.you_can_download_the_consent_here': 'Je kunt het Ouderlijke Toestemming Formulier hier downloaden als je hier nog niet over beschikt. Laat het tekenen door je ouder/voogd en lever het in bij je Awardbegeleider.',
  'footer.copyright': '&copy; Copyright The International Award for Young People',
  'registration_participant.required_award_payment': 'Vereiste Awardcontributie',
  'registration_participant.pay_online_here': 'Betaal online en krijg je transactie id hier',
  'dashboard.activity_log_time': '{hours}u {minutes}min',
  'moduleTitle.award_completed': 'Award afgerond!',
  'notifications.award_approval_request_sent_to_leader': 'De aanvraag tot goedkeuring van je Award is naar je Awardbegeleider gestuurd',
  'notifications.new_participant_event_has_been_completed': 'Nieuw deelnemersevenement is voltooid',
  'notifications.preparation_and_training_approval_sent': 'Goedkeuring Voorbereiding & Training is verstuurd',
  'notifications.reparation_and_training_completed': 'Voorbereiding & Training is voltooid',
  'notifications.your_profile_photo_has_been_edited': 'Je profielfoto is gewijzigd',
  'notifications.your_profile_has_been_edited': 'Je profiel is bewerkt',
  'notifications.new_level_has_started': 'Begonnen met nieuwe Award',
  'notifications.activity_has_been_edited': 'Activiteit is bewerkt',
  'notifications.you_have_been_logged_out': 'Uitloggen...',
  'notifications.logging_out': 'Je bent uitgelogd',
  'label.you_can_send_award_to_leader': 'Je kunt je Award ter goedkeuring naar je Awardbegeleider sturen',
  'label.you_have_completed_all_sections_of_your_award': 'Je hebt alle onderdelen van je Award afgerond. Je kunt het nu ter goedkeuring indienen bij je Awardbeleider. Hieronder kun je een persoonlijke opmerking achterlaten.',
  'label.you_have_now_completed_your_award': 'Je hebt je {level} Award afgerond! Wil je met de volgende Award beginnen?',
  'label.congratulation_your_award_has_been_approved': 'Gefeliciteerd! Je {level} Award is goedgekeurd! <br /> Als je wil, kun je al beginnen met de volgende Award.',
  'moduleTitle.settings': 'Instellingen',
  'moduleTitle.edit_activity': 'Wijzig activiteit',
  'moduleTitle.select_your_major_activity': 'Selecteer je hoofdonderdeel',
  'label.settings': 'Instellingen',
  'label.major_activity_means_that_you_will': 'Het onderdeel dat je als hoofdonderdeel kiest, zal meer tijd kosten in vergelijking met andere onderdelen. Voor Goud en Zilver is de extra vereiste tijd zes maanden, voor Brons geldt een periode van drie maanden.',
  'label.notifications': 'Notificaties',
  'label.my_award': 'Mijn Award',
  'label.physical_recreation': 'Sport',
  'label.skill': 'Individueel Talent',
  'label.service': 'Vrijwilligerswerk',
  'label.my_parent_will_complete_and_sign_form': 'Mijn ouder/voogd zal het Ouderlijke Toestemming Formulier invullen en tekenen',
  'label.please_print_it_tak_it_to_your_parent': 'Wil je dit printen en aan je ouder/voogd geven om het te laten tekenen? Geef het daarna terug aan je Awardbegeleider.',
  'label.change_password': 'Wijzig wachtwoord',
  'label.change_major_activity': 'Wissel hoofdonderdeel',
  'title.change_password': 'Wijzig wachtwoord',
  'label.old_again': 'Oud wachtwoord',
  'label.new_password': 'Nieuw wachtwoord',
  'label.new_password_again': 'Herhaal nieuw wachtwoord',
  'errors.passwords_dont_match': 'Wachtwoorden komen niet overeen',
  'errors.more_than': 'Meer dan {limit}',
  'button.parent_guardian_consent_pdf': 'Toestemming ouder/voogd.pdf',
  'button.send_award_for_approval': 'Stuur Award in ter goedkeuring',
  'button.send_report': 'Verslag insturen',
  'button.terms_and_conditions': 'Internationale Algemene Voorwaarden',
  'button.privacy_policy': 'Privacy beleid',
  'button.save': 'Opslaan',
  'button.start_new_level': 'Begin met de volgende Award',
  'button.change_password': 'Wijzig wachtwoord',
  'button.edit_activity': 'Wijzig activiteit',
  'moduleTitle.file_upload': 'Upload document',
  'label.add_file': 'Voeg document toe',
  'label.description': 'Beschrijving',
  'label.waiting_for_office_sign_off': 'Wachten tot het landelijk Award kantoor aftekend',
  'notifications.file_has_been_uploaded': 'Document is geüpload ',
  'tabs.files': 'Documenten',
  'button.upload': 'Uploaden',
  'button.upload_file': 'Document uploaden',
  'button.add_file': 'Voeg document toe',
  'button.this_activity_has_no_assessor': 'Deze activiteit heeft geen Assessor. Je moet Assessors details instellen voordat je dit indient ter goedkeuring.',
  'label.i_want_to_register_my_award': 'Ik wil mijn Award unit registreren als Zelfstandig Award Centrum.',
  'label.select_sub_operating_authority': 'Selecteer een sub operating authority',
  'label.your_must_first_setup_some_activity': 'Je moet eerst een activiteit instellen.',
  'label.you_cant_change_your_major_activity': 'Je kunt je hoofdonderdeel niet veranderen. Je hoofdonderdeel is al afgerond.',
  'label.s_specific': 'S. Specifiek: Je doel moet niet te vaag zijn. In plaats van :"Ik wil beter viool leren spelen", kun je zeggen, "Ik zou graag F-majeur meester worden op de viool".',
  'label.m_measurable': 'M-Meetbaar: Je moet kunnen vertellen wanneer je je doel bereikt hebt. In plaats van het stellen van doelen als  "Ik wil de maatschappij helpen", zou je kunnen zeggen: "Ik wil mensen helpen die de gaarkeuken bezoeken, door één keer per week vrijwilligerswerk te doen in de keuken". Op deze manier kan het doel gemeten worden.',
  'label.a_achievable': 'A-Acceptabel: Je doel moet haalbaar zijn binnen het kader van de Award. Hoe nobel het ook is om te zeggen dat je "armoede wil eindigen", is het beter om een praktischer doel te stellen als "ik wil zoveel mogelijk geld inzamelen voor de voedselbank".',
  'label.r_realistic': 'R-Realistisch: Dit is bijna hetzelfde als de "A". Is je doel realistisch en haalbaar binnen de tijd die je voor de Award hebt?',
  'label.t_timely': 'T-Tijdsgebonden: Je doel moet ook een deadline stellen. Wanneer wil je je doel bereikt hebben? Bijvoorbeeld: "Ik wil binnen drie maanden de F-Majeur op de viool meester zijn".',
  'label.you_can_upload_here_any_files': 'Je kunt hier je documenten uploaden en delen met je Awardbegeleider',
  'moduleTitle.login_change': 'Wijzig logincodes',
  'notifications.adventurous_journey_modified': 'Expeditie is gewijzigd',
  'tabs.sections': 'Onderdelen',
  'label.change_email': 'Wijzig e-mailadres',
  'title.change_email': 'Wijzig e-mailadres',
  'label.new_email': 'Nieuw e-mailadres',
  'label.new_email_again': 'Bevestig nieuw e-mailadres',
  'errors.emails_dont_match': 'E-mailadressen komen niet overeen',
  'button.change_email': 'Wijzig e-mailadres',
  'notifications.email_with_instructions_has_been_sent_to_your_inbox': 'Er is een e-mail met instructies naar je toegestuurd',
  'global.dofe_name': 'The International Award for Young People',
  'global.or': 'Of',
  'route.landing_page': 'Landingspagina',
  'route.dashboard': 'Dashboard',
  'moduleTitle.notifications': 'Notificaties',
  'moduleTitle.no_notifications': 'Geen notificaties',
  'moduleTitle.new_notifications': 'Nieuwe notificaties',
  'moduleTitle.older_notifications': 'Oude notificaties',
  'moduleTitle.user_guide': 'Gebruikershandleiding',
  'label.user_guide': 'Gebruikershandleiding',
  'notifications.your_password_has_been_changed': 'Je wachtwoord is gewijzigd',
  'label.country': 'Land',
  'label.on_your_smartphone': 'Op je smartphone',
  'label.on_the_web': 'Op internet',
  'label.orb_online': 'ORB online',
  'label.language': 'Taal',
  'moduleTitle.participant_login': 'Deelnemer login',
  'label.for_ios': 'voor iOS',
  'label.for_android': 'voor Android',
  'button.login_as_award_staff': 'Inloggen als Award staff',
  'errors.leader_doesnt_exist': 'Awardbegeleider bestaat niet',
  'global.loading': 'Aan het laden',
  'moduleTitle.award_staff_login': 'Award staff login',
  'formTitle.residential_project_details': 'Details Residentieel Project',
  'label.you_can_also_download_participant': 'Je kunt ook onze gloednieuwe <strong> Deelnemers App</strong> downloaden om altijd en overal toegang te hebben tot het Online Record Book.',
  'label.you_can_also_download_leader': 'Je kunt ook onze gloednieuwe <strong> Awardbegeleiders App</strong> downloaden om altijd en overal toegang te hebben tot het Online Record Book.',
  'notifications.this_role_is_not': 'Deze rol wordt momenteel niet ondersteund',
  'notifications.residential_project_has_been_updated': 'Residentieel Project is geüpdatet.',
  'tabs.participant': 'Deelnemer',
  'tabs.award_staff': 'Award Staff',
  'moduleTitle.edit_residential_project': 'Wijzig Residentieel Project',
  'button.residential_project': 'Wijzig Residentieel Project',
  'notifications.your_login_email_has_been_changed': 'Het e-mailadres waarmee je inlogt, is veranderd',
  'meta.dofe_name': 'The International Award for Young People',
  'notifications.unknown_role_leader': 'Onbekende rol - Gebruik Award Staff login',
  'notifications.unknown_role_participant': 'Onbekende rol - Gebruik Deelnemer login',
  'label.user_guide_web_participant': 'Web-gebruikershandleiding  -  Deelnemer',
  'label.user_guide_app_participant': 'App gebruikershandleiding - Deelnemer',
  'label.note_for_supervisor': 'Opmerking voor Supervisor',
  'label.before_submitting_your_aj': 'Voordat je je Expeditie stuurt naar je Awardbegeleider, heb je eerst toestemming nodig van je {role}. Als je wil, kun je ook een persoonlijke boodschap achterlaten.',
  'button.back_to_home': 'Terug naar Home',
  'moduleTitle.assessor_approval': '{role} Goedkeuring',
  'label.this_aj_has_no_assessor': 'Deze Expeditie heeft geen {role}. Je moet de details updaten voordat je het instuurt ter goedkeuring.',
  'route.not_found': 'Niet gevonden.',
  'notifications.are_you_sure': ' Weet je het zeker?',
  'button.cancel': 'Annuleer',
  'label.add_document': 'Voeg document toe',
  'errors.there_are_currently_no_details_for_your': 'Er zijn op dit moment geen gegevens over je {rol}. Vul aub de ontbrekende gegevens in voor je deze activiteit doorzet voor beoordeling.',
  'moduleTitle.missing_data': 'Ontbrekende gegevens',
  'label.to_send_assessment_request': "Als je een digitale aanvraag wil doen voor een beoordeling, vul dan {rol}'s email in.",
  'label.pending_changes': 'Aanpassingen zijn in behandeling genomen...',
  'label.some_fields_require': 'Sommige velden zijn nog niet in orde',
  'roles.assessor': 'Beoorelaar',
  'roles.supervisor': 'Supervisor',
  'pageTitle.register_participant': 'Deelnemer inschrijven',
  'moduleTitle.revise_message': 'Wijzig bericht',
  'moduleTitle.payment_for_level': 'Betaling voor {Award niveau}',
  'moduleTitle.payment': 'Deelnemer registratie en betaling van de bijdrage',
  'moduleTitle.we_have_sent_you_payment_link': 'We hebben je een mail gestuurd met een betalingslink.',
  'label.required_award_payment': 'Betaling voor de Award is vereist',
  'label.payment_fees': 'Betaling van de bijdrage',
  'label.payment_method': 'Mogelijkheden tot betalen',
  'label.you_will_type_trans_id': 'Je wordt gevraagd om je transaction ID in te typen',
  'label.any_level_previously': 'Welk niveau heb je hiervoor afgerond',
  'label.registering_for_level': 'Registratie voor niveau',
  'notification.payment_link_expired': 'De betalingslink is verlopen',
  'button.pay': 'Betalen',
  'label.registration_updated': 'Je registratie is bijgewerkt, je kunt deze pagina afsluiten.',
  'label.award_leader_receive_payment': 'Je Awardbegeleider wordt geïnformeerd over je betaling.',
  'errors.end_date_after': 'De einddatum moet na de startdatum zijn.',
  'button.back': 'Terug',
  'button.edit_info': 'Wijzig info',
  'moduleTitle.level_detail': 'Detail over het niveau',
  'label.payment_methods': 'Betaal opties',
  'label.address': 'Adres',
  'note.review_filled_participant': 'Check a.u.b. de info ingevuld door de deelnemer. Als er iets niet klopt dan kunt u het aanpassen.\n',
  'moduleTitle.payment_successful': 'De betaling van de deelnemersbijdrage is gelukt.',
  'button.proceed_to_login': 'Ga verder om in te loggen',
  'label.add_additional_activity': 'Voeg een extra activiteit in',
  'moduleTitle.welcome_to_orb': 'Welkom in het Online Record Book',
  'empty_dashboard.not_approved': 'Het ORB helpt je om alles rond je Award goed bij te houden. Maar je profiel is nog niet goedgekeurd door je Awardbegeleider. Voor je begint met je eerste activiteiten, moet je daar even op wachten.',
  'empty_dashboard.approved_1': 'Het ORB helpt je om alles rond je Award goed bij te houden.',
  'empty_dashboard.approved_2': 'Eerst voer je een activiteit in. Dat doe je door links op een te klikken. Je kunt je Awardbegeleider om hulp vragen als het niet lukt.',
  'label.discuss_activity_leader': 'Als je meer dan 1 activiteit kies, bespreek dit dan a.u.b. met je Awardbegeleider.',
  'label.cannot_add_activity': 'Je kunt maximaal 3 activiteiten toevoegen in dit onderdeel. Bespreek dit a.u.b. met je Awardbegeleider.',
  'button.ok': 'OK',
  'label.payment_was_canceled': 'De betaling is geannuleerd door de gebruiker.',
  'label.problem_with_payment': 'Er was een probleem bij je betaling. Neem a.u.b. contact op met het landelijk Award kantoor.',
  'pageTitle.register_leader': 'Register begeleider',
  'pageTitle.registration_complete': 'Registratie voltooid',
  'label.payment_link_expired_or_paid': 'Je hebt je deelnemersbijdrage al betaald OF de betalingslink is verlopen.',
  'label.contact_nao_assistance': 'Neem contact op met het landelijke Award kantoor als je hulp nodig hebt.',
  'label.send_required_amount_to_your_award_leader': 'Stuur het gevraagde bedrag naar je Awardbegeleider of de Coördinator van je Awardunit.',
  'label.fee_can_be_paid': 'De deelnemersbijdrage kan alleen betaald worden met VISA, Master Card of Credit Debit kaarten.',
  'notifications.login_failed_right_tab': 'De login is niet gelukt. Check of je de juiste tab hebt gekozen; deelnemer of staff.',
  'label.i_have_read_privacy_policy': 'Ik heb het Privacy protocol gelezen en ik ga daarmee akkoord. ',
  'errors.invalid_date_format': 'Incorrecte datum',
  'label.no_privacy_policy': 'Je kunt verder gaan door op de finish button te klikken',
  'label.status': 'Status',
  'moduleTitle.attached_with_observation': 'Observatie is toegevoegd',
  'moduleTitle.revise_message_rp': 'Je Residentieel Project is beoordeeld door je Awardbegeleider.',
  'file.activity_section_summary': '{onderdeel} - onderdeel - samenvatting',
  'label.download_section_summary': 'Download de samenvatting over dit onderdeel',
  'label.award_summary': 'Award samenvatting ',
  'btn.download_summary_for_assessor': 'Download the samenvatting voor de Beoordelaar',
  'label.first_activity_started': 'De eerste activiteit gestart',
  'label.hours_completed_required': 'Aantal uren volbracht/vereist',
  'label.weeks_completed_required': 'Aantal weken volbracht/vereist',
  back_to_home: 'Terug naar Home',
  'label.activity_rejected_click': 'Je activiteit is afgekeurd door je Awardbegeleider. Klik voor ',
  'button.more_information': 'meer informatie ',
  'label.attached_file': 'de bijlage',
  'moduleTitle.journey_details': 'Details van de tocht',
  'tabs.activity': 'Activiteit',
  'label.confirm_email': 'Bevestig je e-mailadres',
  'label.aj_rejected_click': 'Je tocht is afgekeurd door je Awardbegeleider. Klik voor',
  'label.verifying_payment': 'Verificatie van betaling',
  'button.finish_and_pay': 'Afronden en betalen',
  'label.payment_not_successful_text': 'De betaling voor deelname is nog niet gelukt, u kunt nu betalen.',
  'label.payment_not_completed': 'De betaling is niet klaar',
  'button.pay_now': 'Betaal nu',
  'label.registration_pending_parental_consent': 'Je registratie wordt behandeld na toestemming van je ouders.',
  'button.edit_observation': 'Voeg een obeservatie toe.',
  'moduleTitle.qualifying': 'Kwalificatie',
  'moduleTitle.practice': 'Oefen',
  'label.first_log_entry': 'Eerste inlog',
  'label.first_log_entry_date': 'Datum van de eerste inlog',
  'label.last_log_entry': 'Laatste inlog',
  'label.last_log_entry_date': 'Datum van de laatste inlog',
  'label.you_can_send_journey_report_for_approval': 'Je kunt je {Expeditie} verslag insturen voor akkoord. ',
  'button.edit_and_resend_report': 'Bewerken en het verslag verzenden',
  'label.your_journey_is_complete': 'Je {type} Expeditie is compleet.',
  'button.add_additional_journey': 'Voeg een extra Expeditie toe.',
  'moduleTitle.edit_journey': 'Bewerk een Expeditie',
  'notifications.assessment_sent': 'Beoordeling is opgestuurd',
  'notifications.file_is_too_big': 'Het bestand kon niet geüpload worden. Waarschijnlijk is het te groot.',
  'notifications.authorization_code_has_expired': '',
  'route.confirm_email': '',
  'label.assessor_needs_account': '',
  'label.company_name': '',
  'label.secondary_email_again': '',
  'label.how_many_years': '',
  'label.no_company_leave_empty': '',
  'label.secondary_phone_number': '',
  'label.secondary_phone_type': '',
  'label.wwc_application_number': '',
  'label.wwc_expiration_date': '',
  'label.you_are_now_registering_as_assessor': '',
  'label.you_have_finished_aj_now_send_to_approval': '',
  'label.your_experience': '',
  'label.your_qualification': '',
  'notifications.waiting_for_assessor_approval': '',
  'button.resend_assessment_request': '',
  'errors.emails_must_be_different': '',
  'moduleTitle.company_details': '',
  'notifications.already_resent_assessment_request': '',
  'route.assessor_dashboard': '',
  'pageTitle.register_assessor': '',
  'wizard.assessor_details': '',
  'wizard.assessor_experience': '',
  'wizard.personal_details': '',
  'button.sign_off': '',
  'button.sign_off_dashed': '',
  'moduleTitle.sign_off': '',
  'label.certify_participant_met_reqs': '',
  'label.assessor_report': '',
  'label.content_update': '',
  'label.comment_on_participant_improvement': '',
  'note.edit_participant_review': '',
  'errors.min_age': '',
  'notifications.assessor_link_expired': '',
  'label.secondary_email': '',
  'moduleTitle.review_participant_info': '',
  'label.loading_payment_gateway': '',
  'label.consent_given_login_as_child': '',
  'notifications.only_one_qualification_journey_per_award': '',
  'label.registration_fees_participant': '',
  'moduleTitle.leader_details': '',
  'label.leader_name': '',
  'label.leader_phone': '',
  'label.leader_email': '',
  'moduleTitle.au_details': '',
  'label.au_name': '',
  'label.assessor_guidelines': '',
  'label.assessor_cond_req': '',
  'label.assessor_ref_handbook': '',
  'label.assessor_ref_online_modules': '',
  'label.participant_has_no_aj_report': '',
  'moduleTitle.participant_details': '',
  'label.participants_has_no_logs': '',
  'label.location_type': '',
  'label.activity_ready_for_signoff': '',
  'label.activities': '',
  'label.choose_how_you_want_to_login': '',
  'roles.leader': '',
  'roles.award_verifier': '',
  'roles.coordinator': '',
  'roles.aj_assessor': '',
  'roles.aj_supervisor': '',
  'roles.instructor': '',
  'roles.nao_staff': '',
  'roles.super_user': '',
  'roles.user': '',
  'roles.viewer': '',
  'roles.authorizing_contact': '',
  'roles.if_staff_superuser': '',
  'roles.if_staff_statistical_user': '',
  'roles.if_staff_viewer': '',
  'roles.aj_instructor': '',
  'label.if_you_have_questions_au': '',
  'label.we_will_send_you_an_email_leader': '',
  'moduleTitle.rejecting_assessor_invitation': '',
  'notifications.assessor_invitation_rejected': '',
  'moduleTitle.participants_list_is_empty': '',
  'label.note_from_participant': '',
  'label.you_can_send_aj_to_leader': '',
  'button.save_report': '',
  'label.this_activity_has_no_assessor': '',
  'label.activity_rejected_click_by_assessor': '',
  'button.reject': '',
  'button.reject_invitation': '',
  'label.reason': '',
  'label.accept_invitation_and_continue': '',
  'pageTitle.registration_reject': '',
  'errors.you_must_be_older_than_register_for_leader': '',
  'label.your_report_approve_now_send_to_leader_without_note': '',
  'button.stop_assessing_this_activity': '',
  'button.confirm': '',
  'moduleTitle.are_you_sure': '',
  'label.content_restore': '',
  'button.stop_editing': '',
  'notifications.activity_has_been_rejected': '',
  'notifications.aj_has_been_rejected': '',
  'notifications.rp_has_been_rejected': '',
  'moduleTitle.additional_files': '',
  'moduleTitle.no_additional_files': '',
  'moduleTitle.stop_assessing_section': '',
  'label.show_security_and_refund_policy': '',
  'moduleTitle.security_and_refund_policy': '',
  'label.fees_payment': '',
  'label.redund_policy': '',
  'label.security_policy': '',
  'label.leave_blank': '',
  'label.frequently_asked_questions': '',
  'label.language_selection_is_disabled_for_iac': '',
  'errors.min_nights_required': '',
  'label.completion_date': '',
  'label.you_are_offline': '',
  'errors.start_date_after_award_start': '',
  'label.participants': '',
  'label.marketing_from_iaf': '',
  'label.marketing_from_oa': '',
  'label.marketing_from_nao': '',
  'label.select_iac': '',
  'label.you_will_be_redirected_to_the_paypal_payment': '',
  'notifications.report_has_been_sent': '',
  'label.processing_paypal_payment': '',
  'label.loading_paypal_gateway': '',
  'label.payment_failed': '',
  'label.payment_has_been_cancelled': '',
  'roles.naa_oa_staff': '',
  'label.download_report_and_upload_signed_version': '',
  'button.download_summary_for_assessor': '',
  'label.pay_online_mastercard': '',
  'label.pay_online_paypal': '',
  'notifications.authorization_code_is_missing': '',
  'errors.unknown_payment_error': '',
  'errors.already_in_use_by_auth_contact': '',
  'roles.if_staff_stat_user': '',
  'moduleTitle.you_have_been_logged_out_due_to_inactivity': '',
  'announcement.survey_description.do_think_people_are_lazy': '',
  'announcement.survey_title.join_our_global_survey': '',
  'announcement.survey_button.if_below_25': '',
  'announcement.survey_button.if_over_25': '',
  'moduleTitle.privacy_and_cookie_policy': '',
  'label.we_have_made_some_important_changes': '',
  'button.i_agree': '',
  'button.see_more_details': '',
  'label.the_cookie_settings_on_this': ''
}
